import { recordSignup } from "../api/claimHunter";

/** When a logged-out visitor last viewed the Evidence API page (ms since epoch). */
const SIGNUP_SOURCE_KEY = "gxl_evidence_signup_source";
/** A new account counts as an Evidence API signup if it follows a logged-out view by this much. */
const SIGNUP_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

export const markEvidenceSignupSource = (): void => {
  try {
    window.localStorage.setItem(SIGNUP_SOURCE_KEY, String(Date.now()));
  } catch {
    /* private mode: the signup just isn't attributed */
  }
};

/** Call right after a new account is created; attributes it if the visitor came from the page. */
export const claimEvidenceSignup = async (): Promise<void> => {
  let seen: number;
  try {
    seen = Number(window.localStorage.getItem(SIGNUP_SOURCE_KEY));
  } catch {
    return;
  }
  if (!seen) return;
  const age = Date.now() - seen;
  try {
    if (age >= 0 && age <= SIGNUP_WINDOW_MS) await recordSignup();
  } catch {
    /* usage stats are best-effort */
  } finally {
    try {
      window.localStorage.removeItem(SIGNUP_SOURCE_KEY);
    } catch {
      /* ignore */
    }
  }
};
